<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBlock_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 1C4.136 1 1 4.136 1 8s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7M2.4 8c0-3.094 2.506-5.6 5.6-5.6 1.295 0 2.485.441 3.43 1.183L3.583 11.43A5.53 5.53 0 0 1 2.4 8M8 13.6a5.53 5.53 0 0 1-3.43-1.183l7.847-7.847A5.53 5.53 0 0 1 13.6 8c0 3.094-2.506 5.6-5.6 5.6"
    />
</svg>
